'use strict';

import React from 'react';

import HomeSearchBase from './HomeSearchBase';
import { SALE, GARAGES } from '../../../consts';
import ExtendSearch from '../ExtendSearch/SaleGarages';

class SaleGarages extends HomeSearchBase {
  constructor (props) {
    super(props);

    this.objectTypes = this.getDictionary().getObjectTypeItems(SALE, GARAGES);
  }

  getRealtyType () {
    return GARAGES;
  }

  getQuickSearchBody (className) {
    return (
      <div className='quick-search-controls'>
        <div className='quick-search-controls__search-menu'>
          <div className={className + ' quick-search-sale-garages'}>
            { this.renderObjectType(this.objectTypes, 'Тип') }
            { this.renderTerritorialDivision() }
            { this.renderAutocompleteLocation() }
            { this.renderPriceGroup(false) }
          </div>
        </div>
        <div className='quick-search-controls__extended-search'>
          { this.renderExtendSearch(ExtendSearch) }
        </div>
      </div>
    );
  }
}

export default SaleGarages;



// WEBPACK FOOTER //
// ./src/ui/Search/HomeSearch/SaleGarages.jsx